module.exports = __webpack_public_path__ + "img/avatar-1.1716d9e3.jpg";